var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    stroke: "#46A358",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.46667C18.1333 9.46667 18.4 9.46667 19.2667 9.53333C21.4667 9.6 22.4667 10.6667 22.5333 12.8C22.6 13.6667 22.6 13.8667 22.6 16C22.6 18.1333 22.6 18.4 22.5333 19.2C22.4667 21.3333 21.4 22.4 19.2667 22.4667C18.4 22.5333 18.2 22.5333 16 22.5333C13.8667 22.5333 13.6 22.5333 12.8 22.4667C10.6 22.4 9.6 21.3333 9.53333 19.2C9.46667 18.3333 9.46667 18.1333 9.46667 16C9.46667 13.8667 9.46667 13.6 9.53333 12.8C9.6 10.6667 10.6667 9.6 12.8 9.53333C13.6 9.46667 13.8667 9.46667 16 9.46667ZM16 8C13.8 8 13.5333 8 12.7333 8.06667C9.8 8.2 8.2 9.8 8.06667 12.7333C8 13.5333 8 13.8 8 16C8 18.2 8 18.4667 8.06667 19.2667C8.2 22.2 9.8 23.8 12.7333 23.9333C13.5333 24 13.8 24 16 24C18.2 24 18.4667 24 19.2667 23.9333C22.2 23.8 23.8 22.2 23.9333 19.2667C24 18.4667 24 18.2 24 16C24 13.8 24 13.5333 23.9333 12.7333C23.8 9.8 22.2 8.2 19.2667 8.06667C18.4667 8 18.2 8 16 8ZM16 11.8667C13.7333 11.8667 11.8667 13.7333 11.8667 16C11.8667 18.2667 13.7333 20.1333 16 20.1333C18.2667 20.1333 20.1333 18.2667 20.1333 16C20.1333 13.7333 18.2667 11.8667 16 11.8667ZM16 18.6667C14.5333 18.6667 13.3333 17.4667 13.3333 16C13.3333 14.5333 14.5333 13.3333 16 13.3333C17.4667 13.3333 18.6667 14.5333 18.6667 16C18.6667 17.4667 17.4667 18.6667 16 18.6667ZM20.2667 10.8C19.7333 10.8 19.3333 11.2 19.3333 11.7333C19.3333 12.2667 19.7333 12.6667 20.2667 12.6667C20.8 12.6667 21.2 12.2667 21.2 11.7333C21.2 11.2 20.8 10.8 20.2667 10.8Z",
    fill: "#46A358",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2b6067c1ad2520b9e6d9dda2cd07bbe3.svg";
export { ForwardRef as ReactComponent };